import { controls } from "../../controls";

const rp562 = {
  label: "OSC.5 -Banking",
  pageLabel: "OSC.5 -Banking",
  starting: true,
  url: "rp562",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({tab: "filter",label: "As on Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"as_on_date",width:"col-sm-2"}),
        
    ...controls.displayText({tab: "filter",label: "",width:"col-sm-3 "}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  
  form:[],

  history: {
    perPage: 10,
    reportHeader: "OSC.5\nClassification of Loans And Advances and Provisioning",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
      {
        Header: "PARTICULARS",
        accessor: "descn",
        rwidth:"*"
      },
      {
        Header: "CATEGORY OF CREDIT FACILITY",
        columns: [
          {
            Header: "ST SAO",
            accessor: "stsao",
            type:"currency",
            width: 150,
            rwidth: 75
          },
          {
            Header: "ST (OSAO)",
            accessor: "osao",
            type:"currency",
            width: 150,
            rwidth: 75
          },
          {
            Header: "CC and OD",
            accessor: "ccandod",
            type:"currency",
            width: 150,
            rwidth: 75
          },
          {
            Header: "Bills",
            accessor: "bills",
            type:"currency",
            width: 150,
            rwidth: 75
          },
          {
            Header: "Term Loans",
            accessor: "termloan",
            type:"currency",
            width: 150,
            rwidth: 75
          },
          {
            Header: "Total",
            accessor: "total",
            type:"currency",
            width: 150,
            rwidth: 75
          }
        ]
      }
    ]
  }
};

export default rp562;